import { FINAL_TERMS_FETCH, FINAL_TERMS_UNLINK, FINAL_TERM_UPDATE, SELECTED_FINAL_TERMS, FINAL_TERMS_RESET_STATE } from './actions';

const initialState = {
  values: [],
  selectedFinalTerms: [],
  isLoading: false,
};

function reducerFinalTerms(state = initialState, action: any): typeof initialState {
  switch (action.type) {
    case FINAL_TERM_UPDATE:
    case FINAL_TERMS_UNLINK:
    case FINAL_TERMS_FETCH: {
      return {
        ...state,
        values: action.payload.values,
        isLoading: action.payload.isLoading,
      };
    }

    case SELECTED_FINAL_TERMS: {
      return {
        ...state,
        selectedFinalTerms: action.payload,
      };
    }

    case FINAL_TERMS_RESET_STATE: {
      return { ...initialState, ...action.payload };
    }

    default:
      return state;
  }
}
export default reducerFinalTerms;
